<template lang="pug">
  #profiles.page
    .columns.is-multiline
      .column.is-3-fullhd.is-4-desktop.is-6-tablet.is-12-mobile(v-for="profile of profiles")
        Profile(v-bind="profile" @update="updateProfile" @name="changeName" @edit="openSettings" @remove="removeProfile")
      .column.is-3-fullhd.is-4-desktop.is-6-tablet.is-12-mobile
        Profile(@create="createProfile" @update="updateProfile")
</template>

<script>
import Profile from "@/components/Profile";

export default {
  name: "profiles",
  components: {
    Profile
  },
  computed: {
    profileList() {
      return this.$store.state.profiles.list;
    },
    profiles() {
      if (this.profileList) {
        return this.profileList.map(item => ({
        ...item,
        active:
          this.activeProfileId &&
          this.isFiltersOpen &&
          this.activeProfileId === item.id
      }));
      }
      return [];
    },
    activeProfileId() {
      return this.$store.state.profiles.activeProfileId;
    },
    isFiltersOpen() {
      return !this.$store.state.filters.isClosed;
    }
  },
  methods: {
    get() {
      this.$store
        .dispatch("getProfiles")
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Get profiles error",
            text
          });
        })
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "profiles",
            status: false
          });
        });
    },
    createProfile(data) {
      this.$store.dispatch("createProfile", data).catch(text => {
        this.$notify({
          type: "error",
          title: "Create profile failure",
          text
        });
      });
    },
    removeProfile(id) {
      this.$store.dispatch("removeProfile", id).catch(text => {
        this.$notify({
          type: "error",
          title: "Delete profile failure",
          text
        });
      });
    },
    changeName({ id, name }) {
      const profiles = [...this.profiles];
      const index = profiles.findIndex(profile => profile.id === id);
      if (index < 0) {
        this.$notify({
          type: "warn",
          title: "Warning",
          text: "Profile not found"
        });
        return;
      }
      this.$store.dispatch("changeProfileName", { id, name });
    },
    // eslint-disable-next-line max-lines-per-function
    updateProfile({ id, data = {} }) {
      const profiles = [...this.profiles];
      const index = profiles.findIndex(profile => profile.id === id);
      if (index >= 0) {
        const enabled = { live: false, dadbee: false };
        Object.keys(data).forEach(key => {
          // eslint-disable-next-line fp/no-mutation
          profiles[index][key] = data[key];
        });
        profiles.forEach(profile => {
          // eslint-disable-next-line fp/no-mutation
          if (profile.live) enabled.live = true;
          // eslint-disable-next-line fp/no-mutation
          if (profile.dadbee) enabled.dadbee = true;
        });
        const status = Object.values(enabled).every(value => value === true);
        if (!status) {
          this.$notify({
            type: "warn",
            title: "Warning",
            text: "Each category must be active at least in one profile."
          });
          return;
        }
        this.$store
          .dispatch("updateProfile", {
            id,
            data,
            name: profiles[index].name
          })
          .catch(text => {
            this.$notify({
              type: "error",
              title: "Update profile failure",
              text
            });
          });
      } else {
        this.$notify({
          type: "error",
          title: "Update profile failure",
          text: "Profile not found"
        });
      }
    },
    openSettings(id) {
      this.$store.dispatch("activeProfileId", id);
      this.$store.dispatch("closeFilters", false);
    }
  },
  mounted() {
    if (this.$store.state.profiles.list === null) this.get();
  },
  beforeDestroy() {
    this.$store.dispatch("closeFilters", true);
  }
};
</script>
